<!-- <label for="lang">
    {{ 'Dashboard.SelectLang' | translate }}
    <select id='lang' #langselect (change)='translate.use(langselect.value); questionStoreService.setLanguage(langselect.value)'>
        <option *ngFor='let lang of translate.getLangs()' [value]="lang">{{ lang }}</option>
    </select>
</label> -->

<!-- <ngx-loading-bar color="#43c3f1" height="3px" diameter="30px"></ngx-loading-bar>   -->
<app-loading-spinner></app-loading-spinner>
<router-outlet></router-outlet>